module.exports = __webpack_public_path__ + "img/passau.e859453.jpg";